/* tcb.js — comportamento do espelho ParoPet (referência Shrine PRO 1.7.0). JS próprio; o JS licenciado do Shrine não é usado.
   Carrossel, galeria, vídeos, datas, filtros e Loox vêm da biblioteca (BELLUNA/TITANOX); gaveta e envio ao carrinho são do Shrine nativo. */
(() => {
  const mobile = () => matchMedia('(max-width: 749px)').matches;
  // dinheiro pelo money_format da loja (o mesmo filtro | money do Liquid)
  const money = c => {
    const f = window.TCB_MONEY_FORMAT || '${{amount}}', n = (c || 0) / 100;
    const fmt = (dec, ts, ds) => { const [i, d] = n.toFixed(dec).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (d ? ds + d : ''); };
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => k === 'amount_no_decimals' ? fmt(0, ',', '.') : k === 'amount_with_comma_separator' ? fmt(2, '.', ',')
      : k === 'amount_no_decimals_with_comma_separator' ? fmt(0, '.', ',') : k === 'amount_with_apostrophe_separator' ? fmt(2, "'", '.') : fmt(2, ',', '.'));
  };
  window.TCB_FMT = money;
  const ARROW = 'm15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z';
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  /* ---------- mini Splide ---------- */
  function splide(comp) {
    const box = comp.querySelector('.splide');
    const track = box && box.querySelector('.splide__track');
    const list = track && track.querySelector('.splide__list');
    if (!list || comp.dataset.txmReady) return;
    const d = comp.dataset, slides = [...list.children];
    let index = 0, built = false, per = 1, gap = 0;
    const cfg = () => {
      const m = mobile();
      per = +(m ? d.slidesMobile : d.slidesDesktop) || 1;
      gap = parseFloat(m ? d.gapMobile : d.gapDesktop) || 0;
      return {pad: parseFloat(m ? d.sidePaddingMobile : d.sidePaddingDesktop) || 0, destroy: (!m && d.destroyDesktop === 'true') || (m && d.destroyMobile === 'true')};
    };
    const pages = () => d.type === 'loop' || d.type === 'fade' ? slides.length : Math.max(1, slides.length - per + 1);
    const loop = d.type === 'loop', fade = d.type === 'fade';
    let clones = 0;
    const go = i => {
      index = loop || fade ? (i + slides.length) % slides.length : Math.max(0, Math.min(i, pages() - 1));
      const w = slides[0].getBoundingClientRect().width + gap;
      if (!fade) list.style.transform = `translateX(${-(index + clones) * w}px)`;
      slides.forEach((s, k) => {
        const vis = k >= index && k < index + per;
        s.classList.toggle('is-active', k === index); s.classList.toggle('is-visible', vis);
        s.classList.toggle('is-prev', k === index - 1); s.classList.toggle('is-next', k === index + per);
        vis ? s.removeAttribute('aria-hidden') : s.setAttribute('aria-hidden', 'true');
        if (d.pauseVideos === 'true') s.querySelectorAll('video').forEach(v => vis ? v.play().catch(() => {}) : v.pause());
      });
      box.querySelectorAll('.splide__pagination__page').forEach((b, k) => {
        b.classList.toggle('is-active', k === index); b.setAttribute('aria-selected', k === index);
      });
      const [p, n] = box.querySelectorAll('.splide__arrow');
      if (p) p.disabled = !loop && !fade && index === 0; if (n) n.disabled = !loop && !fade && index >= pages() - 1;
      if (p) p.setAttribute('aria-label', (loop || fade) && index === 0 ? 'Go to last slide' : 'Previous slide'); if (n) n.setAttribute('aria-label', (loop || fade) && index >= pages() - 1 ? 'Go to first slide' : 'Next slide');
      if (box.dataset[mobile() ? 'mobileAdaptiveHeight' : 'desktopAdaptiveHeight'] === 'true')
        track.style.height = slides[index].getBoundingClientRect().height + 'px';
    };
    const build = () => {
      const c = cfg();
      if (c.destroy) {
        if (built) { box.querySelectorAll('.txm-splide-ui').forEach(e => e.remove()); list.removeAttribute('style'); slides.forEach(s => s.removeAttribute('style')); track.removeAttribute('style'); box.classList.remove('is-initialized', 'is-active', 'is-overflow'); built = false; }
        return;
      }
      box.classList.add('splide--slide', 'splide--ltr', 'splide--draggable', 'is-active', 'is-initialized');
      box.classList.toggle('is-overflow', slides.length > per);
      track.classList.add('splide__track--slide', 'splide__track--ltr', 'splide__track--draggable');
      track.style.paddingLeft = track.style.paddingRight = c.pad + 'px';
      if (fade) { box.classList.replace('splide--slide', 'splide--fade'); track.classList.replace('splide__track--slide', 'splide__track--fade');
        slides.forEach((sl, k) => { sl.style.transform = `translateX(-${k * 100}%)`; sl.style.transition = 'opacity 400ms cubic-bezier(0.25, 1, 0.5, 1)'; }); }
      if (loop && !clones) {  // como o Splide type:loop: cópias antes e depois dos slides reais
        clones = per * 2;  // Splide: 2 × perPage cópias de cada lado, repetindo os slides quando há poucos
        const n = slides.length, mk = sl => { const c = sl.cloneNode(true); c.classList.add('splide__slide--clone'); c.setAttribute('aria-hidden', 'true'); return c; };
        for (let k = 1; k <= clones; k++) list.prepend(mk(slides[((n - k) % n + n) % n]));
        for (let k = 0; k < clones; k++) list.append(mk(slides[k % n]));
      }
      [...list.children].forEach(s => { s.style.marginRight = gap + 'px'; s.style.width = `calc(${100 / per}% + ${-gap + gap / per}px)`; });
      if (!built) {
        const pag = document.createElement('ul');
        pag.className = 'splide__pagination splide__pagination--ltr txm-splide-ui';
        pag.setAttribute('role', 'tablist');
        for (let k = 0; k < pages(); k++) {
          const li = document.createElement('li'); li.setAttribute('role', 'presentation');
          const b = document.createElement('button'); b.type = 'button'; b.className = 'splide__pagination__page' + (d.dotsColor ? ' color-' + d.dotsColor + ' dots-custom-color' : '');
          b.setAttribute('aria-label', 'Go to slide ' + (k + 1)); b.addEventListener('click', () => go(k));
          li.append(b); pag.append(li);
        }
        const arrows = document.createElement('div');
        arrows.className = 'splide__arrows splide__arrows--ltr txm-splide-ui';
        arrows.innerHTML = ['prev', 'next'].map(k => `<button class="splide__arrow${d.arrowsColor ? ' color-' + d.arrowsColor : ''} splide__arrow--${k}" type="button" aria-label="${k === 'prev' ? 'Previous' : 'Next'} slide"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false"><path d="${ARROW}"></path></svg></button>`).join('');
        const oldPag = box.querySelector(':scope > .splide__dots-and-arrows > .splide__pagination, :scope > .splide__pagination');
        const oldArr = box.querySelector(':scope > .splide__dots-and-arrows > .splide__arrows, :scope > .splide__arrows');
        if (oldPag && oldArr) {  // marcação vazia do servidor: preencher no lugar, como o Splide faz
          oldPag.className = pag.className.replace(' txm-splide-ui', ''); oldPag.setAttribute('role', 'tablist');
          oldPag.replaceChildren(...pag.children);
          oldArr.className = arrows.className.replace(' txm-splide-ui', '');
          oldArr.replaceChildren(...arrows.children);
        } else if (/arrows-under/.test(box.className)) {
          const wrap = document.createElement('div'); wrap.className = 'splide__dots-and-arrows txm-splide-ui';
          wrap.append(pag, arrows); box.append(wrap);
        } else { if (d.arrows !== 'false') box.insertBefore(arrows, track); if (d.pagination !== 'false') box.append(pag); }
        box.querySelectorAll('.splide__arrow--prev').forEach(b => b.onclick = () => go(index - 1));
        box.querySelectorAll('.splide__arrow--next').forEach(b => b.onclick = () => go(index + 1));
        let x0 = null;
        track.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, {passive: true});
        track.addEventListener('touchend', e => { if (x0 == null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1)); x0 = null; }, {passive: true});
        if (d.autoplay === 'true' && !comp.txmAutoplay) {  // Splide autoplay: intervalo em segundos, pausa com o mouse em cima
          let hold = false; comp.addEventListener('mouseenter', () => hold = true); comp.addEventListener('mouseleave', () => hold = false);
          comp.txmAutoplay = setInterval(() => { if (!hold && !document.hidden) go(index + 1); }, (parseFloat(d.autoplaySpeed) || 5) * 1000);
        }
        built = true;
      }
      go(index);
    };
    comp.dataset.txmReady = '1';
    build();
    let t; addEventListener('resize', () => { clearTimeout(t); t = setTimeout(build, 120); });
  }

  /* ---------- galeria (media-gallery / slider-component) ---------- */
  function gallery(g) {
    const items = [...g.querySelectorAll('.product__media-list > .product__media-item')];
    const thumbs = [...g.querySelectorAll('.thumbnail-list__item')];
    const list = g.querySelector('.product__media-list');
    if (!items.length) return;
    let cur = Math.max(0, items.findIndex(i => i.classList.contains('is-active')));
    const show = (n, scroll) => {
      cur = (n + items.length) % items.length;
      items.forEach((it, k) => { it.classList.toggle('is-active', k === cur); const v = it.querySelector('video'); if (v) k === cur ? v.play().catch(() => {}) : v.pause(); });
      thumbs.forEach((t, k) => { const b = t.querySelector('button'); b && (k === cur ? b.setAttribute('aria-current', 'true') : b.removeAttribute('aria-current')); });
      const th = thumbs[cur], tl = th && th.parentElement;
      if (th && tl) tl.scrollTo({left: th.offsetLeft - tl.offsetLeft - (tl.clientWidth - th.clientWidth) / 2, behavior: 'smooth'});
      if (scroll && list && (mobile() || list.scrollWidth > list.clientWidth + 4)) list.scrollTo({left: items[cur].offsetLeft - list.offsetLeft, behavior: 'smooth'});
      const dots = g.querySelectorAll('.slider__dot, .slider-counter__link');
      dots.forEach((dt, k) => dt.classList.toggle('slider-counter__link--active', k === cur));
      const gs = g.querySelector('[id^=GalleryStatus]');
      if (gs && g.tcbShow) gs.textContent = ((window.accessibilityStrings && accessibilityStrings.imageAvailable) || 'Image [index] is now available in gallery view').replace('[index]', cur + 1);
    };
    thumbs.forEach((t, k) => t.querySelector('button')?.addEventListener('click', () => show(k, true)));
    const viewer = g.querySelector('slider-component:not(.thumbnail-slider)');
    viewer?.querySelector('.slider-button--prev')?.addEventListener('click', () => show(cur - 1, true));
    viewer?.querySelector('.slider-button--next')?.addEventListener('click', () => show(cur + 1, true));
    const ts = g.querySelector('.thumbnail-slider'), tl = ts?.querySelector('.thumbnail-list');
    ts?.querySelector('.slider-button--prev')?.addEventListener('click', () => tl.scrollBy({left: -tl.clientWidth / 2, behavior: 'smooth'}));
    ts?.querySelector('.slider-button--next')?.addEventListener('click', () => tl.scrollBy({left: tl.clientWidth / 2, behavior: 'smooth'}));
    list?.addEventListener('scroll', () => { if (!mobile() && list.scrollWidth <= list.clientWidth + 4) return; const w = items[0].getBoundingClientRect().width; const n = Math.round(list.scrollLeft / w); if (n !== cur) { cur = n; show(n, false); } }, {passive: true});
    show(cur, false);
    g.tcbShow = show;
  }

  /* ---------- vídeos internos ---------- */
  function videos(root) {
    root.querySelectorAll('internal-video').forEach(iv => {
      const v = iv.querySelector('video'), btn = iv.querySelector('.internal-video__play');
      if (!v) return;
      const hs = [...v.querySelectorAll('source[h-data-src]')];
      if (hs.length && !v.dataset.tcbHv) {
        v.dataset.tcbHv = '1';
        const go = () => {
          hs.forEach(s => { if (/mpegurl/i.test(s.type)) { s.remove(); return; } s.src = s.getAttribute('h-data-src'); s.removeAttribute('h-data-src'); });
          v.load();
          if (iv.dataset.autoplay === 'true') { v.muted = true; v.play().then(() => iv.classList.add('internal-video--playing')).catch(() => {}); }
        };
        if ('IntersectionObserver' in window) { const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { io.disconnect(); go(); } }, {rootMargin: '300px 0px'}); io.observe(iv); } else go();
      }
      if (iv.dataset.autoplay === 'true') { v.muted = true; v.play().then(() => iv.classList.add('internal-video--playing')).catch(() => {}); }
      btn?.addEventListener('click', e => { e.preventDefault(); v.play(); iv.classList.add('internal-video--playing'); });
      v.addEventListener('play', () => iv.classList.add('internal-video--playing'));
      v.addEventListener('pause', () => iv.classList.remove('internal-video--playing'));
    });
  }

  /* ---------- datas de entrega (dynamic-dates do Shrine) ---------- */
  function dynamicDates(root) {
    root.querySelectorAll('dynamic-dates').forEach(dd => {
      const months = (dd.dataset.monthLabels || '').split(',').map(x => x.trim());
      const ord = n => n + (n % 10 == 1 && n != 11 ? 'st' : n % 10 == 2 && n != 12 ? 'nd' : n % 10 == 3 && n != 13 ? 'rd' : 'th');
      const fmt = add => { const d = new Date(); d.setDate(d.getDate() + add); return months[d.getMonth()] + ' ' + ord(d.getDate()); };
      dd.querySelectorAll('[data-dynamic-date="true"]').forEach(p => {
        p.innerHTML = p.dataset.text.replace('[start_date]', fmt(+p.dataset.minDays)).replace('[end_date]', fmt(+p.dataset.maxDays));
      });
    });
  }

  /* ---------- filtros/ordenação (facet-filters-form do Shrine): envia o formulário ao mudar ---------- */
  function facets(root) {
    root.querySelectorAll('facet-filters-form form').forEach(f => {
      f.addEventListener('change', () => f.requestSubmit ? f.requestSubmit() : f.submit());
      f.addEventListener('submit', e => {
        e.preventDefault();
        const q = new URLSearchParams(new FormData(f));
        [...q.keys()].forEach(k => { if (q.get(k) === '') q.delete(k); });
        const cur = new URLSearchParams(location.search);
        if (cur.get('q') && !q.get('q')) q.set('q', cur.get('q'));
        location.search = q.toString();
      });
    });
  }

  /* ---------- página do carrinho: quantidade (+/−/digitação) via /cart/change.js ---------- */
  function cartPage(root) {
    root.querySelectorAll('cart-items quantity-input').forEach(q => {
      const input = q.querySelector('input');
      const line = +input.dataset.index;
      const send = async n => {
        root.querySelectorAll('.cart-item .loading-overlay').forEach(o => o.classList.remove('hidden'));
        await fetch('/cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({line, quantity: Math.max(0, n)})});
        location.reload();
      };
      q.querySelector('[name="minus"]')?.addEventListener('click', () => send(+input.value - 1));
      q.querySelector('[name="plus"]')?.addEventListener('click', () => send(+input.value + 1));
      input.addEventListener('change', () => send(+input.value));
    });
  }

  /* Loox: estrelas estáticas a partir de data-rating / data-raters (mesma marcação que o app monta) */
  function loox(root = document) {
    $$('.loox-rating[data-rating]:not([data-rating-upgraded])', root).forEach(el => {
      const rating = parseFloat(el.dataset.rating || '0'), n = el.dataset.raters || '0';
      if (!+n) return;  // Loox não mostra nota sem avaliações
      el.setAttribute('title', n + ' reviews'); el.setAttribute('aria-label', n + ' reviews'); el.setAttribute('role', 'figure');
      el.dataset.ratingUpgraded = '1';
      let h = '<div class="loox-rating-content">';
      for (let i = 1; i <= 5; i++) {
        const fill = rating >= i - 0.25 ? 'full' : rating >= i - 0.75 ? 'half' : 'empty';
        h += '<svg class="loox-icon" viewBox="0 0 24 24" data-lx-fill="' + fill + '" aria-hidden="true"' + (i === 1 ? ' role="presentation"><title>' + n + ' reviews</title>' : '>') +
             '<use href="#looxicons-rating-icon"></use></svg>';
      }
      const pat = el.dataset.pattern;
      const lab = pat ? pat.replace(/\{\{?\s*(?:average|rating)\s*\}?\}/g, rating).replace(/\{\{?\s*(?:count|raters|total)\s*\}?\}/g, n) : '&nbsp;(' + n + ')';
      el.innerHTML = h + '<span class="loox-rating-label" aria-hidden="true">' + (pat ? '&nbsp;' : '') + lab + '</span></div>';
      if (el.dataset.contentSize) el.style.fontSize = el.dataset.contentSize + 'px';  // tamanho do bloco Loox (data-content-size)
    });
  }



  /* Loox: widget de avaliações = documento renderizado da referência (estático), num iframe srcdoc com altura pelo conteúdo */
  function looxFrames(root = document) {
    $$('[data-tcb-loox-frame]', root).forEach(w => {
      const src = (mobile() && w.querySelector('script.tcb-loox-doc-m')) || w.querySelector('script.tcb-loox-doc');
      if (!src || w.querySelector('iframe')) return;
      const f = document.createElement('iframe');
      f.id = 'looxReviewsFrame'; f.title = 'Reviews widget'; f.setAttribute('frameborder', '0'); f.setAttribute('scrolling', 'no');
      f.style.cssText = 'overflow:hidden;width:100%;border:0;box-shadow:unset;outline:unset;color-scheme:none;';
      f.srcdoc = src.textContent;
      const fit = () => { try { const d = f.contentDocument; const h = Math.max(d.documentElement.scrollHeight, d.body.scrollHeight); f.style.height = h + 'px'; f.setAttribute('height', h + 'px'); w.style.height = h + 'px'; } catch (e) {} };
      f.addEventListener('load', () => { fit(); setTimeout(fit, 400); setTimeout(fit, 1500); });
      addEventListener('resize', () => setTimeout(fit, 150));
      w.append(f);
    });
  }
  /* ---------- gaveta do carrinho: a gaveta nativa do Shrine (seção tcb-cart-drawer), atualizada por Section Rendering ---------- */
  const SECTION = 'tcb-cart-drawer';
  const cart = {
    el: () => document.querySelector('cart-drawer'),
    open() {
      const d = cart.el(); if (!d) { location.href = '/cart'; return; }
      d.classList.add('animate', 'active'); document.body.classList.add('overflow-hidden');
      setTimeout(() => d.querySelector('.drawer__close')?.focus({preventScroll: true}), 300);
    },
    close() {
      const d = cart.el(); if (!d) return;
      d.classList.remove('active'); document.body.classList.remove('overflow-hidden');
    },
    // HTML da seção renderizada pela Shopify -> conteúdo da gaveta que está na página (mantém aberta/fechada)
    render(sections) {
      const html = sections && sections[SECTION], d = cart.el();
      if (!html || !d) return;
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer');
      if (!fresh) return;
      d.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
      d.replaceChildren(...fresh.childNodes);
    },
    count(n) {
      document.querySelectorAll('#cart-icon-bubble').forEach(a => {
        let b = a.querySelector('.cart-count-bubble');
        if (n > 0) {
          if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; b.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>'; a.append(b); }
          b.firstElementChild.textContent = n; b.lastElementChild.textContent = n + (n === 1 ? ' item' : ' items');
        } else if (b) b.remove();
      });
    },
    refreshCount: () => fetch('/cart.js', {headers: {Accept: 'application/json'}}).then(r => r.json()).then(c => cart.count(c.item_count)).catch(() => {}),
    busy: false,
    change(line, quantity, row) {
      if (cart.busy) return; cart.busy = true;
      row?.querySelector('.loading-overlay')?.classList.remove('hidden');
      fetch('/cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({line, quantity: Math.max(0, quantity), sections: SECTION, sections_url: location.pathname})})
        .then(r => r.json()).then(c => {
          if (c.status) { const e = document.getElementById('CartDrawer-LineItemError-' + line); if (e) { e.querySelector('.cart-item__error-text').textContent = c.description || c.message; } return; }
          cart.render(c.sections); cart.count(c.item_count);
          if (/^\/cart\/?$/.test(location.pathname)) location.reload();
        })
        .catch(() => {})
        .finally(() => { cart.busy = false; row?.querySelector('.loading-overlay')?.classList.add('hidden'); });
    }
  };
  if (window.customElements && !customElements.get('cart-drawer'))  // o botão fechar da referência chama this.closest('cart-drawer').close()
    customElements.define('cart-drawer', class extends HTMLElement { open() { cart.open(); } close() { cart.close(); } });

  function cartDrawer() {
    if (document.documentElement.dataset.tcbCart) return;
    document.documentElement.dataset.tcbCart = '1';
    document.addEventListener('click', e => {
      const d = cart.el(), t = e.target;
      if (d && d.contains(t)) {
        if (t.id === 'CartDrawer-Overlay') { cart.close(); return; }
        const row = t.closest('.cart-item'), qi = row && row.querySelector('input.quantity__input');
        if (!row || !qi) return;
        const line = +qi.dataset.index, q = parseInt(qi.value, 10) || 0;
        if (t.closest('cart-remove-button')) { e.preventDefault(); cart.change(line, 0, row); }
        else if (t.closest('[name="minus"]')) { e.preventDefault(); cart.change(line, q - 1, row); }
        else if (t.closest('[name="plus"]')) { e.preventDefault(); cart.change(line, q + 1, row); }
        return;
      }
      // ícone e links do carrinho abrem a gaveta, como na referência
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || !d) return;
      const a = t.closest('a[href]');
      if (a && /^\/cart\/?(?:[?#].*)?$/.test(a.getAttribute('href') || '')) { e.preventDefault(); cart.open(); }
    });
    document.addEventListener('change', e => {
      const d = cart.el();
      if (!d || !d.contains(e.target) || !e.target.matches('input.quantity__input')) return;
      cart.change(+e.target.dataset.index, parseInt(e.target.value, 10) || 0, e.target.closest('.cart-item'));
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && cart.el()?.classList.contains('active')) cart.close(); });
    window.txShowCart = () => cart.open();
  }

  /* ---------- BUNDLE & SAVE (quantity-breaks do Shrine): faixa escolhida, variante por unidade, preço principal e envio por unidade ---------- */
  const qbState = {};
  function quantityBreaks() {
    const qb = document.querySelector('quantity-breaks');
    if (!qb || qb.dataset.tcbQb) return;
    qb.dataset.tcbQb = '1';
    const productP = fetch(location.pathname.replace(/\/$/, '') + '.js').then(r => r.json()).catch(() => null);
    const form = document.querySelector('product-form.main-product-form form[action="/cart/add"]');
    const idInput = form && form.querySelector('input[name="id"]');
    const noZeros = c => money(c).replace(/[.,]00(?=\D*$)/, '');
    const checked = () => qb.querySelector('input[name="quantity"]:checked');
    const label = inp => inp && qb.querySelector('label[for="' + inp.id + '"]');
    // preço por faixa = variante principal × q × percentage-left − desconto fixo (conta do Shrine)
    const paint = p => {
      const v = p && idInput && p.variants.find(x => x.id === +idInput.value) || (p && p.variants[0]);
      if (!v) return;
      const cmpU = v.compare_at_price || v.price;
      qb.querySelectorAll('label.quantity-break').forEach(lab => {
        const q = +lab.dataset.quantity || 1, pl = parseFloat(lab.dataset.percentageLeft || '1'), fx = +(lab.dataset.fixedDiscount || 0);
        const price = Math.round(v.price * q * pl - fx), cmp = cmpU * q;
        const pr = lab.querySelector('.quantity-break__price strong') || lab.querySelector('.quantity-break__price');
        if (pr) pr.textContent = noZeros(price);
        const cp = lab.querySelector('.quantity-break__compare-price'); if (cp) cp.textContent = noZeros(cmp);
        const cap = lab.querySelector('.quantity-break__caption');
        if (cap && /\[amount_saved\]/.test(cap.dataset.text || '')) cap.textContent = cap.dataset.text.replace('[amount_saved]', noZeros(cmp - price));  // a referência mostra até "You save £0"
        if (cp) cp.classList.toggle('hidden', cmp <= price);
        lab.dataset.tcbPrice = price; lab.dataset.tcbCompare = cmp;
      });
      const lab = label(checked());
      if (lab && qb.dataset.updatePdpPrices === 'true') {  // preço principal = total da faixa
        document.querySelectorAll('.product-page-price, [id^="price-template"]').forEach(box => {
          box.querySelectorAll('.price-item--regular, .price-item--sale').forEach(sp => {
            if (sp.closest('.unit-price')) return;
            sp.textContent = (sp.tagName === 'S' || sp.closest('s') || sp.closest('.price__compare-price')) ? money(+lab.dataset.tcbCompare) : money(+lab.dataset.tcbPrice);
          });
          const pc = box.querySelector('.badge__percentage-saved'), c = +lab.dataset.tcbCompare, pr = +lab.dataset.tcbPrice;
          if (pc && c > pr) pc.textContent = Math.round((c - pr) * 100 / c);  // o Shrine arredonda (o Liquid trunca)
        });
      }
    };
    productP.then(paint);
    qb.addEventListener('change', e => {
      if (e.target.name === 'quantity') { productP.then(paint); return; }
      const item = e.target.closest('.quantity-break__selector-item');
      if (!item) return;
      productP.then(p => {  // variante desta unidade pelas opções escolhidas
        if (!p) return;
        const sel = {}; item.querySelectorAll('select').forEach(s => { sel[s.name.replace(/^options\[|\]$/g, '')] = s.value; });
        const v = p.variants.find(x => p.options.every((o, i) => sel[o.name || o] == null || x.options[i] === sel[o.name || o]));
        if (v) item.dataset.selectedId = v.id;
      });
    });
    document.addEventListener('change', e => { if (e.target.name === 'id' && e.target.closest('form[action="/cart/add"]')) productP.then(paint); });
    // envio: faixa ≥ 2 com seletores por unidade -> items[k][id], como o Shrine
    qbState.items = () => {
      const lab = label(checked());
      const units = lab ? [...lab.querySelectorAll('.quantity-break__selector-item')].map(x => x.dataset.selectedId).filter(Boolean) : [];
      return units.length >= 2 ? units : null;
    };
  }

  /* ---------- PDP: envio ao carrinho como o product-form do Shrine (FormData para /cart/add com a seção da gaveta).
     Passa por window.fetch de propósito: o seletor "pp-" da referência intercepta esse envio e junta guia grátis,
     patch com nome e porta-saquinhos no mesmo pedido. ---------- */
  function pdp() {
    $$('product-form form[action="/cart/add"]').forEach(form => {
      if (form.dataset.tcbPdp) return; form.dataset.tcbPdp = '1';
      form.addEventListener('submit', async e => {
        e.preventDefault();
        const pf = form.closest('product-form');
        const btn = form.querySelector('[type=submit]');
        const errBox = pf && pf.querySelector('.product-form__error-message-wrapper'), err = errBox && errBox.querySelector('.product-form__error-message');
        if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
        btn.classList.add('loading'); btn.setAttribute('aria-disabled', 'true'); btn.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
        const fd = new FormData(form);
        const units = qbState.items && form.closest('product-form.main-product-form') ? qbState.items() : null;
        if (units) {  // BUNDLE & SAVE com variante por unidade: uma linha por unidade, sem o id principal (como o Shrine)
          fd.delete('id'); fd.delete('quantity');
          units.forEach((id, k) => { fd.append(`items[${k}][quantity]`, '1'); fd.append(`items[${k}][id]`, id); });
        }
        fd.append('sections', SECTION); fd.append('sections_url', location.pathname);
        try {
          const r = await window.fetch((window.routes && routes.cart_add_url) || '/cart/add', {method: 'POST', headers: {Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest'}, body: fd});
          const j = await r.json();
          if (!r.ok || j.status) throw new Error(j.description || j.message || 'Error');
          if (errBox) { errBox.hidden = true; errBox.classList.add('hidden'); }
          if (!cart.el()) { location.href = '/cart'; return; }
          cart.render(j.sections); cart.open(); cart.refreshCount();
        } catch (x) {
          if (err) err.textContent = x.message; if (errBox) { errBox.hidden = false; errBox.classList.remove('hidden'); }
        } finally {
          btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); btn.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        }
      });
    });

    // preço pela variante escolhida (o seletor da referência troca input[name="id"] e dispara "change")
    const main = document.querySelector('product-form.main-product-form form[action="/cart/add"]');
    if (!main || !/\/products\//.test(location.pathname)) return;
    const productP = fetch(location.pathname.replace(/\/$/, '') + '.js').then(r => r.json()).catch(() => null);
    function setPrice(v) {
      document.querySelectorAll('.product-page-price, [id^="price-template"], div.price[class*="price-template--"]').forEach(pr => {
        pr.querySelectorAll('.price-item--regular, .price-item--sale, .price-item--last').forEach(sp => {
          if (sp.closest('.unit-price')) return;
          if (sp.tagName === 'S' || sp.closest('s') || sp.closest('.price__compare-price')) sp.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
          else sp.textContent = money(v.price);
        });
        const pc = pr.querySelector('.badge__percentage-saved');  // SAVE x% e estado de promoção da variante (conta inteira, como o Liquid)
        if (pc && v.compare_at_price > v.price) pc.textContent = Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        if (pr.classList.contains('price')) pr.classList.toggle('price--on-sale', v.compare_at_price > v.price);
      });
    }
    document.addEventListener('change', e => {
      if (e.target.name !== 'id' || !e.target.closest('form[action="/cart/add"]')) return;
      productP.then(p => { const v = p && p.variants.find(x => x.id === +e.target.value); if (v) setPrice(v); });
    });
  }

  /* ---------- cabeçalho (Shrine/Dawn): gaveta do menu, modal de busca, seletor de país/moeda ---------- */
  function header() {
    // gaveta do menu mobile: details + classe menu-opening (animação do tema)
    $$('header-drawer details, .menu-drawer-container').forEach(d => {
      if (d.dataset.tcbHd) return; d.dataset.tcbHd = '1';
      const sum = d.querySelector(':scope > summary');
      const close = () => { d.classList.remove('menu-opening'); document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet'); setTimeout(() => { d.removeAttribute('open'); }, 250); sum.setAttribute('aria-expanded', 'false'); };
      const open = () => { d.setAttribute('open', ''); setTimeout(() => d.classList.add('menu-opening'), 10); document.body.classList.add('overflow-hidden-mobile'); sum.setAttribute('aria-expanded', 'true'); };
      sum.addEventListener('click', e => { e.preventDefault(); d.hasAttribute('open') ? close() : open(); });
      d.addEventListener('keyup', e => { if (e.key === 'Escape') close(); });
      d.querySelectorAll('.menu-drawer__close-button, .menu-drawer__close').forEach(b => b.addEventListener('click', e => { e.preventDefault(); close(); }));
      d.addEventListener('click', e => { if (e.target === d.querySelector('.menu-drawer')) close(); });
      // submenus
      d.querySelectorAll('details').forEach(sd => {
        const ss = sd.querySelector(':scope > summary'); if (!ss) return;
        ss.addEventListener('click', e => { e.preventDefault(); sd.setAttribute('open', ''); setTimeout(() => sd.classList.add('menu-opening'), 10); ss.closest('.has-submenu, .menu-drawer__navigation')?.classList.add('submenu-open'); });
        sd.querySelectorAll('.menu-drawer__close-button').forEach(b => b.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); sd.classList.remove('menu-opening'); setTimeout(() => sd.removeAttribute('open'), 250); }));
      });
    });
    // modal de busca
    $$('details-modal details').forEach(d => {
      if (d.dataset.tcbDm) return; d.dataset.tcbDm = '1';
      const sum = d.querySelector(':scope > summary');
      const close = () => { d.removeAttribute('open'); sum.setAttribute('aria-expanded', 'false'); document.body.classList.remove('overflow-hidden'); };
      sum.addEventListener('click', e => { e.preventDefault(); if (d.hasAttribute('open')) return close(); d.setAttribute('open', ''); sum.setAttribute('aria-expanded', 'true'); document.body.classList.add('overflow-hidden'); d.querySelector('input[type=search]')?.focus(); });
      d.querySelectorAll('.modal__close-button, [type=reset]').forEach(b => b.addEventListener('click', e => { if (b.classList.contains('modal__close-button')) { e.preventDefault(); close(); } }));
      d.addEventListener('keyup', e => { if (e.key === 'Escape') close(); });
      d.addEventListener('click', e => { if (e.target.classList.contains('modal-overlay')) close(); });
    });
    // seletor de país/moeda (localization-form): abre a lista e envia o país escolhido
    $$('localization-form').forEach(lf => {
      if (lf.dataset.tcbLf) return; lf.dataset.tcbLf = '1';
      const btn = lf.querySelector('button.disclosure__button, button[aria-expanded]'), list = lf.querySelector('.disclosure__list-wrapper, ul');
      const form = lf.querySelector('form');
      if (btn && list) {
        btn.addEventListener('click', e => { e.preventDefault(); const o = btn.getAttribute('aria-expanded') === 'true'; btn.setAttribute('aria-expanded', String(!o)); list.hidden = o; });
        document.addEventListener('click', e => { if (!lf.contains(e.target)) { btn.setAttribute('aria-expanded', 'false'); list.hidden = true; } });
      }
      lf.querySelectorAll('a[data-value], .disclosure__link[data-value]').forEach(a => a.addEventListener('click', e => {
        e.preventDefault();
        const inp = form && (form.querySelector('input[name="country_code"]') || form.querySelector('input[name="locale_code"]'));
        if (inp) { inp.value = a.dataset.value; form.submit(); }
      }));
    });
  }

  /* ---------- lazysizes (a referência carrega lazysizes.min.js): img.lazyload com data-src/data-srcset ao chegar perto da tela ---------- */
  function lazySizes(root) {
    const imgs = $$('img.lazyload[data-src], img.lazyload[data-srcset]', root).filter(i => !i.dataset.tcbLz);
    if (!imgs.length) return;
    const load = i => {
      if (i.dataset.srcset) i.srcset = i.dataset.srcset;
      if (i.dataset.sizes === 'auto') i.sizes = Math.max(1, i.getBoundingClientRect().width) + 'px';
      if (i.dataset.src) i.src = i.dataset.src;
      i.classList.remove('lazyload'); i.classList.add('lazyloaded');
    };
    const io = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { io.unobserve(e.target); load(e.target); } }), {rootMargin: '400px 0px'}) : null;
    imgs.forEach(i => { i.dataset.tcbLz = '1'; io ? io.observe(i) : load(i); });
  }

  /* ---------- filtro de preço (price-range do Shrine): alças e faixa pelo valor dos campos; arrastar atualiza os campos e envia o filtro ---------- */
  function priceRange(root) {
    $$('price-range', root).forEach(pr => {
      if (pr.dataset.tcbPr) return; pr.dataset.tcbPr = '1';
      const max = parseFloat(pr.dataset.max) || 0;
      const [gte, lte] = [pr.querySelector('input[name$=".gte"]'), pr.querySelector('input[name$=".lte"]')];
      const hMin = pr.querySelector('.price-slider__handle--min'), hMax = pr.querySelector('.price-slider__handle--max');
      const range = pr.querySelector('.price-slider__range'), slider = pr.querySelector('.price-slider');
      const lMin = pr.querySelector('[data-label="min"]'), lMax = pr.querySelector('[data-label="max"]');
      if (!gte || !lte || !hMin || !hMax || !max) return;
      const val = (i, d) => { const v = parseFloat(i.value); return isNaN(v) ? d : Math.min(max, Math.max(0, v)); };
      const pct = v => (v / max) * 100;
      const fmt = v => (Number.isInteger(v) ? String(v) : v.toFixed(2));
      const paint = labels => {  // rótulos: o texto do servidor fica até o cliente mexer
        const a = val(gte, 0), b = val(lte, max);
        hMin.style.left = pct(a) + '%'; hMax.style.left = pct(b) + '%';
        if (range) { range.style.left = pct(a) + '%'; range.style.right = (100 - pct(b)) + '%'; }
        if (labels && lMin) lMin.textContent = a ? fmt(a) : '0';
        if (labels && lMax) lMax.textContent = b === max ? pr.dataset.max : fmt(b);
      };
      [gte, lte].forEach(i => i.addEventListener('input', () => paint(true)));
      [hMin, hMax].forEach(h => h.addEventListener('pointerdown', e => {
        e.preventDefault(); h.setPointerCapture(e.pointerId);
        const isMin = h === hMin;
        const move = ev => {
          const r = slider.getBoundingClientRect();
          let v = Math.round(Math.min(1, Math.max(0, (ev.clientX - r.left) / r.width)) * max * 100) / 100;
          if (isMin) v = Math.min(v, val(lte, max)); else v = Math.max(v, val(gte, 0));
          (isMin ? gte : lte).value = (isMin && v === 0) || (!isMin && v === max) ? '' : v;
          paint(true);
        };
        const up = () => { h.removeEventListener('pointermove', move); h.removeEventListener('pointerup', up); (isMin ? gte : lte).dispatchEvent(new Event('change', {bubbles: true})); };
        h.addEventListener('pointermove', move); h.addEventListener('pointerup', up);
      }));
      paint();
    });
  }

  /* ---------- vídeos com <source data-src> (video.lazyVdHide): carregam ao entrar na tela ---------- */
  function lazyVideos(root) {
    const vids = $$('video.lazyVdHide', root).filter(v => !v.dataset.tcbLv);
    if (!vids.length) return;
    const load = v => {
      v.querySelectorAll('source[data-src]').forEach(s => { if (/mpegurl/i.test(s.type)) { s.remove(); return; } s.src = s.dataset.src; s.removeAttribute('data-src'); });  // como a referência: só o MP4 (sem HLS)
      v.load(); v.classList.remove('lazyVdHide');
      if (v.autoplay || v.hasAttribute('autoplay') || v.closest('[data-autoplay="true"]')) { v.muted = true; v.play().catch(() => {}); }
    };
    const io = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { io.unobserve(e.target); load(e.target); } }), {rootMargin: '300px 0px'}) : null;
    vids.forEach(v => { v.dataset.tcbLv = '1'; io ? io.observe(v) : load(v); });
  }

  /* ---------- botão flutuante "voltar ao topo": aparece após 400 px de rolagem (como na referência) ---------- */
  function scrollTop() {
    const b = document.querySelector('.scroll-to-top-btn');
    if (!b || b.dataset.tcbSt) return; b.dataset.tcbSt = '1';
    window.handleScrollToTop = window.handleScrollToTop || (() => window.scrollTo({top: 0, behavior: 'smooth'}));
    const upd = () => { b.style.display = window.scrollY > 400 ? '' : 'none'; };
    addEventListener('scroll', upd, {passive: true}); upd();
  }

  /* ---------- papéis de acessibilidade que o global.js do Dawn aplica (summary e ícone do carrinho) ---------- */
  function a11yRoles() {
    $$('[id^="Details-"] > summary, details-modal summary').forEach(s => {  // mesma regra do global.js/DetailsModal do Dawn
      if (s.dataset.tcbRole) return; s.dataset.tcbRole = '1';
      if (!s.hasAttribute('role')) s.setAttribute('role', 'button');
      const d = s.parentElement, upd = () => s.setAttribute('aria-expanded', d && d.hasAttribute('open') ? 'true' : 'false');
      upd(); d && d.addEventListener('toggle', upd);
      new MutationObserver(upd).observe(d, {attributes: true, attributeFilter: ['open']});
    });
    $$('#cart-icon-bubble, a.header__icon--cart').forEach(a => { a.setAttribute('role', 'button'); a.setAttribute('aria-haspopup', 'dialog'); });
    $$('facet-remove a, a.facets__reset').forEach(a => a.setAttribute('role', 'button'));  // FacetRemove do Dawn
  }

  const run = () => {
    const root = document;
    $$('splide-component').forEach(splide);
    $$('media-gallery').forEach(gallery);
    [() => videos(root), () => dynamicDates(root), () => facets(root), () => cartPage(root), () => loox(root), () => looxFrames(root), cartDrawer, pdp, header, () => lazySizes(root), () => priceRange(root), quantityBreaks, () => lazyVideos(root), scrollTop, a11yRoles]
      .forEach(f => { try { f(); } catch (e) { console.error('[tcb]', e); } });  // um módulo com erro não derruba os demais
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', run) : run();
  window.TCB = { loox, splide, cart };
})();
